import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import SearchHighlight from "./SearchHighlight";

const longDate = (d) => {
  try {
    return new Date(d).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
  } catch (e) {
    return "";
  }
};

export default function SearchPaywall({ story, isLoggedIn, onClose, onSubscribe, onLogin }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const { publication } = story;
  const where = `${longDate(story.publishedDate)}${story.pageNumber ? ` · Page ${story.pageNumber}` : ""}`;

  return createPortal(
    <div className="ns-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="ns-paywall" role="dialog" aria-modal="true" aria-labelledby="ns-pw-title">
        <div className="ns-pw-top">
          <span className="ns-group-label">From your search</span>
          <button type="button" className="ns-pw-close" aria-label="Close" onClick={onClose}>✕</button>
        </div>

        <h2 id="ns-pw-title" className="ns-pw-title">
          {story.title || `Page ${story.pageNumber} of ${publication.name}`}
        </h2>

        <div className="ns-pw-meta">
          <span className="ns-logo ns-logo-sm">
            {publication.logo ? <img src={publication.logo} alt="" /> : <span>{publication.name.charAt(0)}</span>}
          </span>
          <span className="ns-pw-pub">{publication.name}</span>
          <span>· {where}</span>
        </div>

        <p className="ns-pw-snippet">
          …<SearchHighlight text={story.snippet} />…
        </p>

        <p className="ns-pw-note">
          This story is in the {longDate(story.publishedDate)} edition of {publication.name}
          {story.pageNumber ? `, on page ${story.pageNumber}` : ""}. Subscribe to read it and every edition.
        </p>

        <button type="button" className="ns-pw-primary" onClick={onSubscribe}>
          See subscription options
        </button>

        {!isLoggedIn && (
          <p className="ns-pw-login">
            Already a subscriber?{" "}
            <button type="button" className="ns-link" onClick={onLogin}>Log in</button>
          </p>
        )}
      </div>
    </div>,
    document.body
  );
}
